import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { MenuItem } from '@mui/material';
export default function ActionMenuList(_ref) {
    var items = _ref.items, onClose = _ref.onClose;
    return items.map(function (item, i) { /*#__PURE__*/ return React.createElement(MenuItem, _extends({
        key: item.id,
        color: "secondary",
        dense: true,
        disableRipple: true,
        onClick: function (e) { return onClose(e.currentTarget.id); }
    }, item, {
        sx: _objectSpread({
            justifyContent: 'start',
            columnGap: 1,
            px: 1,
            fontSize: 'base',
            minInlineSize: 120,
            borderRadius: 1
        }, item.sx)
    })); });
}
